import React, { useState, useEffect, useContext } from "react";
import { useRouter } from "next/router";
import GenericHTMLPageComponent from "../../components/GenericHTMLPageComponent";
import PageHead from "../../components/PageHead";
import EventKit from "../../data/EventKit";
import AuthKit from "../../data/AuthKit";
import eventStatus from "../../data/enums/eventStatus";
import { UserContext } from "../../contexts/UserContext";
import { ChatContext } from "../../contexts/ChatContext";
import Custom404 from "../../components/Custom404";
import hasContent from "../../util/hasContent";
import CustomCSSRenderer from "../../components/CustomCSSRenderer";

export default function IdlePage() {
  const router = useRouter();
  const { event } = router.query;
  const { hasUnreadMessages } = useContext(ChatContext);

  const eventKit = new EventKit();
  const authKit = new AuthKit();

  const { me, setMe } = useContext(UserContext);

  const [eventData, setEventData] = useState(null);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (event) {
      const token = authKit.getToken();
      eventKit
        .getEventDetail(event)
        .then((data) => {
          setEventData(data);
          setShowContent(true);
        })
        .catch((errors) => {
          console.log(errors);
          setShowContent(true);
        });

      if (token && !me) {
        eventKit.getEventUserMe(event).then((data) => {
          setMe(data);
        }).catch((errors) => { });
      }
    }
  }, [event]);

  useEffect(() => {
    if (eventData) {
      if (eventKit.shouldRender(eventData, me)) {
        router.push(`/${event}`);
      } else {
        if (eventData.status === eventStatus.ACTIVE) {
          router.push(`/${event}/register`);
        }
        if (
          eventData.status === eventStatus.IDLE ||
          eventData.status === eventStatus.DRAFT
        ) {
          authKit.deleteToken();
        }
      }
    }
  }, [eventData, me]);

  function renderIdleContent() {
    return (
      <div
        className="view-image-custom d-flex align-items-center justify-content-center"
        style={{
          backgroundImage:
            eventData.backgroundImageLarge &&
            `url(${
              eventData.backgroundImageLarge
                ? eventData.backgroundImageLarge
                : ""
            })`,
        }}
        data-bg={
          eventData.backgroundImageLarge
            ? eventData.backgroundImageLarge
            : "/assets/bgNotSet.png"
        }
      >
        {hasContent(eventData.idleText) && (
          <div
            className={`idle-wrapper ${
              eventData.logotypeLink ? "" : "has-no-logo"
            }`}
          >
            {eventData.logotypeLink && (
              <img src={eventData.logotypeLink} className="sing-in__logo" />
            )}
            <p
              className="idle-wrapper__idle-text"
              dangerouslySetInnerHTML={{ __html: eventData.idleText }}
            ></p>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {showContent && (
        <>
          {eventData && (
            <>
              <PageHead
                eventTitle={eventData.title}
                hasUnreadMessages={hasUnreadMessages}
              />
              <CustomCSSRenderer eventCSS={eventData?.customCss} />
              {!eventKit.shouldRender(eventData) && renderIdleContent()}
            </>
          )}
          {!eventData && (
            <>
              <PageHead eventTitle="404 Event not found" />
              <Custom404 text="There is no available event with this adress" />
            </>
          )}
        </>
      )}
    </>
  );
}
